import { render, staticRenderFns } from "./DialogLottoRule.vue?vue&type=template&id=4eca2efe"
import script from "./DialogLottoRule.vue?vue&type=script&lang=js"
export * from "./DialogLottoRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports